import { render } from "./BulkEditUnitBelongs.vue?vue&type=template&id=86cba5f8"
import script from "./BulkEditUnitBelongs.vue?vue&type=script&lang=js"
export * from "./BulkEditUnitBelongs.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BulkEditUnitBelongs.vue?vue&type=style&index=0&id=86cba5f8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__